<template>
  <div class="area-chart-container" :class="{'emptygraph': isEmpty === true }">
    <VueApexCharts height="400" type="area" :options="options" :series="chartSeries" />
  </div>
</template>

<script>
/* eslint-disable arrow-parens */
import _ from 'lodash';
import { format } from 'date-fns';
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'LineChart',
  props: ['series', 'categories', 'colors', 'xAxistype'],
  components: {
    VueApexCharts,
  },
  created() {
    this.updateChartData();
    this.updateChartSeries();
  },
  data() {
    return {
      options: {},
      chartSeries: {},
    };
  },
  computed: {
    isEmpty() {
      return _.isEmpty(this.chartSeries[0].data);
    },
  },
  methods: {
    transformSecond(second) {
      if (this.xAxistype === 'date') {
        return format(new Date(second), 'dd/MM/yyyy HH:mm');
      }
      const minutes = Math.floor(second / 60);
      const seconds = second - minutes * 60;
      let secs = Math.floor(seconds);
      if (secs < 10) {
        secs = `0${secs}`;
      }
      return `${minutes}:${secs}`;
    },
    updateChartData() {
      this.options = {
        chart: {
          id: 'area-chart',
          toolbar: {
            show: true,
            tools: {
              download: '<i class="fas fa-download"></i>',
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
        },
        tooltip: {
          y: {
            formatter: (value) => `${value.toFixed(2)} %`,
          },
        },
        colors: this.colors,
        xaxis: {
          type: this.xAxistype === 'date' ? 'datetime' : 'numeric',
          tickAmount: 10,
          tickPlacement: 'on',
          labels: {
            show: true,
            hideOverlappingLabels: true,
            showDuplicates: false,
            trim: true,
            minHeight: undefined,
            formatter: (value) => this.transformSecond(value),
          },
        },
        yaxis: {
          forceNiceScale: true,
          decimalsInFloat: 2,
          min: 0,
          labels: {
            show: true,
            hideOverlappingLabels: true,
            showDuplicates: false,
            trim: false,
            minHeight: undefined,
            formatter: (value) => `${value} %`,
          },
        },
        noData: {
          text: 'ไม่มีข้อมูล',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#000',
            fontSize: '24px',
            fontFamily: undefined,
          },
        },
        responsive: [
          {
            breakpoint: 575.98,
            options: {
              chart: {
                height: 220,
                toolbar: {
                  show: false,
                },
              },
              stroke: {
                width: 1,
              },
              yaxis: {
                labels: {
                  maxWidth: 40,
                  formatter: (value) => `${value.toFixed(0)} %`,
                },
              },
              xaxis: {
                tickPlacement: 'on',
                tickAmount: 6,
                labels: {
                  show: true,
                  hideOverlappingLabels: true,
                  showDuplicates: false,
                  trim: false,
                  minHeight: undefined,
                  formatter: (value) => this.transformSecond(value),
                },
              },
            },
          },
        ],
      };
    },
    updateChartSeries() {
      this.chartSeries = this.series;
    },
  },
  watch: {
    async series() {
      await this.updateChartSeries();
    },
    async categories() {
      await this.updateChartData();
    },
    async colors() {
      await this.updateChartData();
    },
  },
};
</script>

<style lang="scss" scoped>
.emptygraph {
  background-color: gainsboro;
}
</style>
